import React from 'react'

export function ArrowDynamic() {
  return (
    <svg width="28" height="12" viewBox="0 0 28 12" fill="currentColor">
      <path
        className="button-arrow__pen"
        d="M12.7578 10.4854L17.0005 6.24271 M17 6.24268L12.7574 2.00004"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <rect className="button-arrow__line" x="1" y="5.7" rx="0.5" stroke="currentColor" />
    </svg>
  )
}
